module.exports = __webpack_public_path__ + "static/media/保腎5.1541511c.png";